"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Parser = _interopRequireDefault(require("./Parser"));
var CustomChat = /*#__PURE__*/
function (_PureComponent) {
  (0, _inheritsLoose2.default)(CustomChat, _PureComponent);
  function CustomChat() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = CustomChat.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    var handleParse = this.props.handleParse;
    handleParse();
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      pageId = _this$props.pageId,
      themeColor = _this$props.themeColor,
      loggedInGreeting = _this$props.loggedInGreeting,
      loggedOutGreeting = _this$props.loggedOutGreeting,
      dataRef = _this$props.dataRef,
      greetingDialogDisplay = _this$props.greetingDialogDisplay,
      greetingDialogDelay = _this$props.greetingDialogDelay;
    return _react.default.createElement("div", {
      className: "fb-customerchat",
      page_id: pageId,
      theme_color: themeColor,
      logged_in_greeting: loggedInGreeting,
      logged_out_greeting: loggedOutGreeting,
      greeting_dialog_display: greetingDialogDisplay,
      greeting_dialog_delay: greetingDialogDelay,
      "data-ref": dataRef
    }, children);
  };
  return CustomChat;
}(_react.PureComponent);
(0, _defineProperty2.default)(CustomChat, "defaultProps", {
  children: undefined,
  themeColor: undefined,
  loggedInGreeting: undefined,
  loggedOutGreeting: undefined,
  dataRef: undefined,
  greetingDialogDisplay: undefined,
  greetingDialogDelay: undefined
});
var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(_Parser.default, null, function (_ref) {
    var handleParse = _ref.handleParse;
    return _react.default.createElement(CustomChat, (0, _extends2.default)({}, props, {
      handleParse: handleParse,
      ref: ref
    }));
  });
});
exports.default = _default;